/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Add_Rest_HrInputs */

const en_ui_thresholds_add_rest_hr = /** @type {(inputs: Ui_Thresholds_Add_Rest_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add resting HR`)
};

const de_ui_thresholds_add_rest_hr = /** @type {(inputs: Ui_Thresholds_Add_Rest_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhepuls eintragen`)
};

/**
* | output |
* | --- |
* | "Add resting HR" |
*
* @param {Ui_Thresholds_Add_Rest_HrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_add_rest_hr = /** @type {((inputs?: Ui_Thresholds_Add_Rest_HrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Add_Rest_HrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_add_rest_hr(inputs)
	return de_ui_thresholds_add_rest_hr(inputs)
});